/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S41_TitleInputs */

const es_tyc_obligations_s41_title = /** @type {(inputs: Tyc_Obligations_S41_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.1 Uso Autorizado`)
};

const en_tyc_obligations_s41_title = /** @type {(inputs: Tyc_Obligations_S41_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.1 Authorized Use`)
};

/**
* | output |
* | --- |
* | "4.1 Authorized Use" |
*
* @param {Tyc_Obligations_S41_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s41_title = /** @type {((inputs?: Tyc_Obligations_S41_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S41_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s41_title(inputs)
	return en_tyc_obligations_s41_title(inputs)
});
export { tyc_obligations_s41_title as "tyc.obligations.s41_title" }